import { PagingService } from './../../../../@AppService/Services/PagingService';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../../@AppService/Services/notification.service';
import { PagingModel } from '../../../../@AppService/Models/PagingModel';
import { Router } from '@angular/router';
import { BaseComponent } from '../base/base.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent extends BaseComponent implements OnInit {
  componentModel: PagingModel;
  userId: number = 0;
  notifications: any[] = [];
  isnotreadcount: number = 0;
  constructor(public override service: NotificationService, public override route: Router, public paging: PagingService) {
    super(route, service, paging, '');
    // this.userId = +this.login.token.userId;
    this.componentModel = new PagingModel();
  }

  ngOnInit() {
    this.service.getByUserId(this.userId).subscribe((data:any) => {
      this.notifications = data['notifications'];
      this.isnotreadcount = data['notReadCount'];
    });
  }
}
